'use client';

import { ReactNode, useEffect } from 'react';

import { Cart } from '@lib/cart/definitions';
import { User } from '@lib/user/definitions';

import { useCartStore } from './useCartStore';
import { useUserStore } from './useUserStore';

interface hydrateStoresProps {
  user?: User;
  cart?: Cart;
}
function hydrateStores({ user, cart }: Readonly<hydrateStoresProps>) {
  useUserStore.setState({ user });
  useCartStore.setState({ cart });
}

interface StoreHydrationWrapperProps extends hydrateStoresProps {
  children: ReactNode;
}

export function StoreHydrationWrapper({
  children,
  user,
  cart,
}: Readonly<StoreHydrationWrapperProps>) {
  useEffect(() => {
    hydrateStores({ user, cart });
  }, [user, cart]);

  return children;
}
